export const range = (start: number, end: number, step = 1) =>
  Array.from({ length: (end - start) / step + 1 }, (value, index) => start + index * step)
